<template>
	<div :class="{Base:1,loading}" >

		<div class="BaseNav" >
			<a v-if="logo_path.includes('://')" :href="logo_path" class="Logo"  ><img src="/img/configaro-logo.svg" alt="Configaro"></a>
			<router-link v-else :to="{path:logo_path}" class="Logo" ><img src="/img/configaro-logo.svg" alt="Configaro"></router-link>
			<div class="BaseNavUser">

				<div v-if="expiring_trials.length" class="ExpiringPrompt">
					<button
						v-for="org in expiring_trials"
						:key="org.id"
						@click="Event.$emit('activate-org',org)"
						:class="expiredExpires(org.subscription.trial_ends_at)"
						>
						{{ dsplApostrophize(org.name) }} trial {{ expiredExpires(org.subscription.trial_ends_at) }} {{ timeToExpiry(org.subscription.trial_ends_at) }}
						<b>Activate now</b>
					</button>
				</div>

				<UserNav />
			</div>
		</div>

		

		<div class="BaseBody" >
			<router-view></router-view>
		</div>

		<!-- MODAL -->
		<Modal />
		<Toasts />
	</div>
</template>

<script>

	import Modal from "../components/Modal.vue";
	import UserNav from "../components/UserNav.vue";
	import Toasts from "../components/Toasts.vue";
	import ActivateAccount from '../modals/ActivateAccount';
	import { mapState } from 'vuex'

	export default {

		components : {
			Modal,
			Toasts,
			UserNav,
		},

		data(){
			return {
				Event,
				loading : false,
			}
		},

		mounted(){

			Event.$on('redirectToLogin', () => {
				this.$router.push({name:'auth.login',query: { redirect: this.$route.fullPath }});
			});

			Event.$on('page-loading', () => {
				this.loading = true;
			});

			Event.$on('page-loaded', () => {
				this.loading = false;
			});

			Event.$on('activate-org', (org) => {
				
				Event.$emit('modal-open', {
					component : ActivateAccount,
					props : { org }
				});
				
			});
		},

		computed:{
			...mapState('auth',[
						'user',
						'orgs',
			]),
			expiring_trials(){
				return (this.orgs||[]).filter((org)=>{
					return !org.subscription || !org.subscription.subscribed; 
				});
			},
			logo_path(){
				if(['auth.login','templates'].includes(this.$route.name)) return publicBaseUrl;
				return '/';
			}
		},

		methods : {
			expiredExpires(mysql_string){
				var d = moment.utc(mysql_string);
				var diff = moment().diff(d);
				return diff>0 ? 'expired' : 'expires';
			},
			timeToExpiry(mysql_string){
				var d = moment.utc(mysql_string);
				var diff = moment().diff(d);
				var since = moment.duration(diff);
				
				return  d.fromNow();
			}
		},

	}

</script>